import React, { FC, useState, createRef, useRef } from 'react';
import injectSheet from 'react-jss';
import Tooltip from 'HOC/Tooltip';
import { Input } from 'Components/Inputs';
import DownArrow from 'Assets/ui/dropdownarrow.svg';
import styleSheet from './styles';

interface Props {
  classes?: any;
  items: any;
  selectedOptions?: any[];
  inputValue?: string;
  defaultValue?: string;
  onDropdownChange?: (e: object) => void;
  onSearchBarChange?: (e: object) => void;
}
const SearchableDropdown: FC<Props> = (props: Props) => {
  const [dropdownIsOpen, setDropdownIsOpen] = useState(false);
  const [inputState, setInputState] = useState(false);

  const {
    classes,
    items,
    selectedOptions,
    inputValue,
    defaultValue,
    onDropdownChange,
    onSearchBarChange,
  } = props;

  const inputRef = useRef();

  const filterInputRef = createRef<HTMLInputElement>();

  const onChange = (event: any) => {
    const response = items[event.currentTarget.id];
    onDropdownChange({ target: { value: response } });
    setDropdownIsOpen(false);
  };

  const openDropdown = () => {
    setDropdownIsOpen(true);
  };

  const closeDropdown = (event: any) => {
    if (
      !event.currentTarget.contains(event.relatedTarget) &&
      event.target.name !== 'selectionInput'
    ) {
      setDropdownIsOpen(false);
    }
  };

  const changeInputState = () => {
    setInputState(!inputState);
  };

  const handleInputChange = (event: any) => {
    onSearchBarChange(event);
  };

  const focusFilterInput = () => {
    filterInputRef.current.focus();
  };

  const constructDropdownList = () => {
    return (
      <>
        {items.map((item, index) => {
          const dropdownItem = (
            <div
              key={item.label}
              className={`${classes.dropdownItem}`}
              onClick={onChange}
              id={`${index}`}
              tabIndex={0}
              onKeyUp={(event) => event.key === 'Enter' && onChange(event)}
              role="button"
            >
              <span className={classes.dropdownItemText}>{item.label}</span>
            </div>
          );
          return dropdownItem;
        })}
      </>
    );
  };

  return (
    <>
      <div
        onFocus={openDropdown}
        onBlur={closeDropdown}
        tabIndex={-1}
        style={{ position: 'relative' }}
      >
        <div className={`${inputState && classes.hidden}`}>
          {defaultValue.length >= 32 ? (
            <Tooltip
              position="top"
              text={defaultValue}
              offsetTop={-43}
              offsetLeft={5}
            >
              <Input
                type="text"
                name="selectionInput"
                value={`${defaultValue.slice(0, 27)}...`}
                onFocus={changeInputState}
                onBlur={focusFilterInput}
                domRef={inputRef}
                ariaLabel="selectionInput"
                overrideStyles={{
                  padding: '7px 10px 6px 10px',
                  height: '34px',
                  width: '244px',
                  border: '1.2px solid #085FE5',
                  borderRadius: '4px',
                  color: '#085FE5',
                  fontSize: '14px',
                  fontWeight: '500',
                  lineHeight: '15px',
                }}
              />
            </Tooltip>
          ) : (
            <Input
              type="text"
              name="selectionInput"
              value={defaultValue}
              onFocus={changeInputState}
              onBlur={focusFilterInput}
              domRef={inputRef}
              ariaLabel="selectionInput"
              overrideStyles={{
                padding: '7px 10px 6px 10px',
                height: '34px',
                width: '244px',
                border: '1.2px solid #085FE5',
                borderRadius: '4px',
                color: '#085FE5',
                fontSize: '14px',
                fontWeight: '500',
                lineHeight: '15px',
              }}
            />
          )}
        </div>
        <div
          className={classes.dropdownArrow}
          style={{
            transform: dropdownIsOpen
              ? 'scale(0.8) rotate(180deg)'
              : 'scale(0.8) rotate(0deg)',
          }}
        >
          <DownArrow />
        </div>
        <div className={`${!inputState && classes.hidden}`}>
          <Input
            type="text"
            name="filterInput"
            domRef={filterInputRef}
            value={inputValue}
            onBlur={changeInputState}
            onChange={handleInputChange}
            ariaLabel="selectionInput"
            overrideStyles={{
              padding: '7px 10px 6px 10px',
              height: '34px',
              width: '244px',
              border: '1.2px solid #085FE5',
              borderRadius: '4px',
              color: '#085FE5',
              fontSize: '14px',
              fontWeight: '500',
              lineHeight: '15px',
            }}
          />
        </div>
        <div
          className={`${classes.dropdown} ${
            !dropdownIsOpen && classes.hidden
          } ${
            (inputState || (dropdownIsOpen && selectedOptions.length > 0)) &&
            classes.selected
          }`}
        >
          {constructDropdownList()}
        </div>
      </div>
    </>
  );
};

SearchableDropdown.defaultProps = {
  classes: {},
  selectedOptions: [],
  inputValue: '',
  defaultValue: '',
  onDropdownChange: () => {},
  onSearchBarChange: () => {},
};

export default injectSheet(styleSheet)(SearchableDropdown);
